var _rect, _g, _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 33,
    viewBox: "0 0 440 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_260_3097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 3,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 3,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_260_3097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.691 27C204.691 27 207.573 18.7199 221.191 22.5757C234.809 26.4315 237.691 18.1514 237.691 18.1514",
    stroke: "#F25C05",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.691 31.4248C205.691 31.4248 208.573 23.1448 222.191 27.0005C235.809 30.8563 238.691 22.5762 238.691 22.5762",
    stroke: "#F10505",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.691 35.8487C205.691 35.8487 208.573 27.5686 222.191 31.4243C235.809 35.2801 238.691 27 238.691 27",
    stroke: "#A60402",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 11,
    r: 4,
    fill: "#FFF387"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 11,
    r: 4,
    fill: "#D91438"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 2,
    r: 2,
    fill: "#D91438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.66 17L159 8.33973L150.34 17L159 25.6602L167.66 17ZM1.31134e-07 18.5L159 18.5L159 15.5L-1.31134e-07 15.5L1.31134e-07 18.5Z",
    fill: "url(#paint0_linear_260_3097)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.34 17L281 25.6602L289.66 17L281 8.33973L272.34 17ZM440 15.5L281 15.5L281 18.5L440 18.5L440 15.5Z",
    fill: "url(#paint1_linear_260_3097)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_260_3097",
    x1: 168,
    y1: 17,
    x2: 0,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_260_3097",
    x1: 272,
    y1: 17,
    x2: 440,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.d5c1a3b045b5faf0078ba25dfab172ce.svg";
export { ForwardRef as ReactComponent };